export const REBUZZ_BOOSTS = {
  freeContent: 'freeContent',
  content: 'content',
  freePromotion: 'freePromotion',
  promotion: 'promotion',
};
